const dictionary = {
  attributes: {
    password_confirmation: 'password confirmation',
    newPassword: 'new password'
  },
  messages: {
    confirmed: (field) => `${field} doesn't match`
  }
}
export default dictionary
